// extracted by mini-css-extract-plugin
export default {"container":"RoleBanner-module__container--OHcMr"};